import React,{Component} from 'react'

import Navigation from '../components/Navigation';
import NavigationMobile from '../components/NavigationMobile';
import Footer from '../components/Footer';
import FooterMobile from '../components/FooterMobile';
// sections
import News from '../components/sections/News';
import Preorder from '../components/sections/Preorder';
import Merch from '../components/sections/Merch';
import Events from '../components/sections/Events';
import About from '../components/sections/About';
import Videos from '../components/sections/Videos';
import Images from '../components/sections/Images';
import Signup from '../components/sections/Signup';
import Contact from '../components/sections/Contact';

import Typekit from 'react-typekit';
import jump from 'jump.js'

import initReactFastclick from 'react-fastclick';
initReactFastclick();

import './index.less';

//helper
// import scrollTo from '../components/scrollHelper';


const Menu = [
'Start',
'News',
'Album',
'Merch',
'Termine',
'Band',
'Videos',
'Fotos',
'Kontakt',
]


class Index extends Component{
  constructor(){
    super();
    this.state = {
      currentSection: '#',
      res: null,
      menuIsOpen: false,
      footerIsOpen: false,
      impressum:false,
      sections: [...document.querySelectorAll(".section")]
    }
  }

  onScroll(){
    this.lastScrollY = window.scrollY;
    this.requestTick();
  }

  update() {
    // var sections = [...document.querySelectorAll('.section')];
    const {currentSection,sections} = this.state;

    const scrollTop = document.body.scrollTop || document.body.parentNode.scrollTop;

    var newCurrentSection = '';

    if(sections.length){
      // console.log(scrollTop);

      sections.map((el,idx) => {
        if(el.offsetTop - 20 < scrollTop){
          newCurrentSection = el.id !== undefined ? el.id : '';
        }
      }
      );

      if(currentSection !== '#' + newCurrentSection){
        this.setState({
          currentSection: '#' + newCurrentSection
        })
      }


    }

    this.ticking = false;
  };

  requestTick() {
    if (!this.ticking) {
      window.requestAnimationFrame(this.update.bind(this));
      this.ticking = true;
    }
  };

  openMenu = () => {
    document.body.style.overflow = 'hidden';
    this.setState({
      menuIsOpen: true,
      footerIsOpen: false
    })
  }

  openFooter = () => {
    document.body.style.overflow = 'hidden';
    this.setState({
      menuIsOpen: false,
      footerIsOpen: true
    })
  }

  close = () => {
    document.body.style.overflow = '';
    this.setState({
      menuIsOpen: false,
      footerIsOpen: false
    })
  }

  isXLarge = mql => {
    if(mql.matches) {
       this.setState({res: 'xlarge'});
       console.log('xlarge');
    }
  }
  isLarge = mql => {
    if(mql.matches) {
       this.setState({res: 'large'});
       console.log('large');
    }
  }
  isMedium = mql => {
    if(mql.matches) {
       this.setState({res: 'medium'});
       console.log('medium');
    }
  }
  isSmall = mql => {
    if(mql.matches) {
       this.setState({res: 'small'});
       console.log('small');
    }
  }



  componentDidMount(){

    // this.setState({
    //   data: window.data
    // })

    // fetch('http://preview.skacore.de/api/api/')
    //   .then(res => res.json())
    //   .then(data => {
    //     // console.log(data);
    //     this.setState({data:data});
    //     this.setState({sections:[...document.querySelectorAll(".section")]});
    //   });

    this.setState({sections: [...document.querySelectorAll(".section")]});

    this.ticking = false;
    window.addEventListener('scroll', () => this.onScroll(), false);

    this.xlargeBreakpoint = matchMedia("screen and (min-width: 1441px)");
    this.largeBreakpoint = matchMedia("screen and (min-width: 980px) and (max-width : 1440px)");
    this.mediumBreakpoint = matchMedia("screen and (min-width : 600px) and (max-width : 979px)");
    this.smallBreakpoint = matchMedia("screen and (max-width : 600px)");

    this.xlargeBreakpoint.addListener(this.isXLarge);
    this.largeBreakpoint.addListener(this.isLarge);
    this.mediumBreakpoint.addListener(this.isMedium);
    this.smallBreakpoint.addListener(this.isSmall);

    this.isXLarge(this.xlargeBreakpoint);
    this.isLarge(this.largeBreakpoint);
    this.isMedium(this.mediumBreakpoint);
    this.isSmall(this.smallBreakpoint);


  }

  goTo = e => {

    const {res,menuIsOpen,footerIsOpen,impressum} = this.state;

    if(impressum){
      this.setState({
        impressum:false
      })
    }
    let section = e.target.getAttribute("href");

    if(res != 'small' ){
      e.preventDefault();
      jump(section == '#' ? '.background' : section);
    }

    this.setState({
      currentSection: section
    });

    if(menuIsOpen || footerIsOpen){
      this.close();
    }


  }

  render(){
    const {res,menuIsOpen,footerIsOpen,currentSection,impressum} = this.state;
    const {data} = this.props;

    // if(!data){
    //   return (
    //     <div className={`background ${res} `}>
    //       <Typekit kitId="vgy2hap" />
    //       {
    //         res == 'large' || res == 'xlarge'
    //         ? <Navigation currentSection={currentSection} goTo={this.goTo} menuItems={Menu}/>
    //         : <NavigationMobile currentSection={currentSection} goTo={this.goTo} menuItems={Menu.filter(el => el !== 'Kontakt')} isActive={menuIsOpen || footerIsOpen} showMenu={menuIsOpen} closeAction={this.close} openAction={this.openMenu} res={res}/>
    //       }
    //       <div className='loading'>Wird geladen...</div>
    //       <Footer />
    //     </div>
    //   );
    // }

    if(impressum){
      return (
        <div className={`background ${res} impressum`}>
          <Typekit kitId="vgy2hap" />
          {
            res == 'large' || res == 'xlarge'
            ? <Navigation currentSection={currentSection} goTo={this.goTo} data={data} menuItems={Menu}/>
            : <NavigationMobile currentSection={currentSection} data={data} goTo={this.goTo} menuItems={Menu.filter(el => el !== 'Kontakt')} isActive={menuIsOpen || footerIsOpen} showMenu={menuIsOpen} closeAction={this.close} openAction={this.openMenu} res={res}/>
          }
          <div className='impressum-content' dangerouslySetInnerHTML={{__html: data.impressum}}></div>
          <Footer data={data} showImpressum={() => this.setState({impressum:true})} />
        </div>
      )
    }
    return (
      <div className={`background ${res}`}>
        <Typekit kitId="vgy2hap" />
        {
          res == 'large' || res == 'xlarge'
          ? <Navigation currentSection={currentSection} goTo={this.goTo} data={data} menuItems={Menu}/>
          : <NavigationMobile currentSection={currentSection} data={data} goTo={this.goTo} menuItems={Menu.filter(el => el !== 'Kontakt')} isActive={menuIsOpen || footerIsOpen} showMenu={menuIsOpen} closeAction={this.close} openAction={this.openMenu} res={res}/>
        }
        <News id="News" data={data} res={res}/>
        <Preorder id="Album" data={data}  res={res}/>
        <Merch id="Merch" data={data}  res={res}/>
        <Events id="Termine" data={data}  res={res}/>
        <About id="Band" data={data} res={res} />
        <Videos id="Videos" data={data} res={res} />
        <Images id="Fotos" data={data} res={res} />
        <Signup id="Signup" data={data} res={res} />
        <Contact res={res} data={data} id="Kontakt" />
        <Footer data={data} showImpressum={() => this.setState({impressum:true})} />
      </div>

    )
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/pages/index.js